
  <div class="tooltip-arrow"></div>
  <div class="tooltip-inner"><ng-content></ng-content></div>
  


// WEBPACK FOOTER //
// ./node_modules/ng-mdb-pro/free/tooltip/tooltip.component.ts.TooltipContainerComponent.html